import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDataGlance from './baseGlances/baseDataGlance'



export default function DiningTimes(props) {

    const { t } = useTranslation();
    return (
        <>
            <BaseDataGlance cssContentClass='dining-times-glance-body'
                cssHeadingClass='dining-times-glance-heading'
                cssIconClass='icons8-alarm-clock-filled'
                Heading={t('DiningTimes')}
                DataPoint1={props.DP1 + ' ' + t('Average') + ' ' + t('Minutes')}
            ></BaseDataGlance>
        </>
    );
}